/* eslint-disable no-unused-vars */
import { Expression } from "./Expression";

export enum OrderType {
  asc = "asc",
  desc = "desc",
}

export class OrderItem extends Expression {
  name: string;
  value: OrderType;
  constructor(
    name: string,
    value: OrderType,
    activated = true,
    visible = true,
    meta:any
  ) {
    super(activated, visible, meta);
    this.name = name;
    this.value = value;
  }

  /**
   * 获取值
   * @returns {name,order}
   */
  getQueryValue() {
    return {
      name: this.name,
      order: this.value
    };
  }

  /**
   * 设置值
   * @param name name
   * @param value value
   */
  setValue(value: OrderType) {
    this.value = value;
  }

  /**
   * 获取value
   * @returns value
   */
  getValue() {
    return this.value;
  }
}
